var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var isDebugEnabled = function () {
    if (typeof window === 'undefined')
        return false;
    return localStorage.getItem('CINCEL_DEBUG') === 'true';
};
export var logger = {
    log: function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (isDebugEnabled()) {
            var now = new Date().toISOString().split('T')[1].replace('Z', '');
            console.log.apply(console, __spreadArray(["%c[".concat(now, "] [CINCEL] ").concat(message), 'color: #3b82f6; font-weight: bold'], args, false));
        }
    },
    warn: function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (isDebugEnabled()) {
            var now = new Date().toISOString().split('T')[1].replace('Z', '');
            console.warn.apply(console, __spreadArray(["[".concat(now, "] [CINCEL] ").concat(message)], args, false));
        }
    },
    error: function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var now = new Date().toISOString().split('T')[1].replace('Z', '');
        console.error.apply(console, __spreadArray(["[".concat(now, "] [CINCEL] ").concat(message)], args, false));
    }
};
